import EmployeeListingSpec from '@Components/Shared/Specs/EmployeeListingSpec';
import EmployeeListingSearchSpec from '@Components/Shared/Specs/EmployeeListingSearchSpec';
import Modal from '@Components/Shared/Modals/Modal';
import EmployeeListingSort from '@Components/Sorts/EmployeeListingSort';
import EmployeeListingFeaturedDomain from '@Components/Sorts/EmployeeListingFeaturedDomain';
import translator from '@Components/Utilities/Translator';
import atoms from '@Components/Utilities/SandhillsAtoms';
import { useRecoilValue } from 'recoil';

const EmployeeListingModal = (props) => {
    const {
        listingId,
        listingTitle,
        inventoryManagementUrl,
        toggleEmployeeModal,
        isDetailPage,
        specs,
        sortApplied,

        // Comes from the EmployeeViewModal.cs
        DomainID,
        CompanySpecs,
        ContactSpecs,
        MachineSpecs,
        WholesaleSpecs,
        SearchingSpecs,
        AuctionSpecs,
        SortValues
    } = props;

    const currentSite = useRecoilValue(atoms.currentWebsite);
    return (
        <Modal contentClassName='employee-listing-modal' onEscapeKeyClose={toggleEmployeeModal}>
            <Modal.Header onClose={toggleEmployeeModal}>
                <Modal.Title>
                    {listingTitle}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <h4>
                    Listing ID: {listingId} {inventoryManagementUrl && <>(<a href={inventoryManagementUrl} target='_blank' aria-label={"View in Inventory Management (" + translator.translate('sandhills.opensinanewtab') + ")"}>
                        View in Inventory Management</a>)</>}
                </h4>
                <h4>Domain Name: {currentSite.ProperDisplayDomainName}</h4>
                <h4>Primary Domain ID: {DomainID}</h4>
                {isDetailPage ?
                    <section>
                        <EmployeeListingSpec title="Auction Location Details" specs={AuctionSpecs} />
                        <EmployeeListingSpec title="Company Information" specs={CompanySpecs} />
                        <EmployeeListingSpec title="Retail Contact Information" specs={ContactSpecs} />
                        <EmployeeListingSpec title="Wholesale Contact Information" specs={WholesaleSpecs} />
                        <EmployeeListingSpec title="Machine Location" specs={MachineSpecs} />
                        <EmployeeListingFeaturedDomain listingId={listingId} targetSite={currentSite.CurrentSite} topLevelDomain={currentSite.TopLevelDomain} />
                        {props.HashValue &&
                            <h5>Hash Value: {props.HashValue}</h5>
                        }
                    </section>
                    :
                    <section>
                        <EmployeeListingSpec title="Auction Location Details" specs={AuctionSpecs} />
                        <EmployeeListingSort sortApplied={sortApplied} sortValues={SortValues} listingId={listingId} domainName={currentSite.Site.DomainName} HashValue={props.HashValue} />
                        <EmployeeListingSpec title="Display Specs" specs={specs} />
                        <EmployeeListingSearchSpec title="Searching Specs" specs={SearchingSpecs} />
                        <EmployeeListingFeaturedDomain listingId={listingId} targetSite={currentSite.CurrentSite} topLevelDomain={currentSite.TopLevelDomain} />
                    </section>}
            </Modal.Body>
        </Modal>
    );
};

export default EmployeeListingModal;